import { useMutation } from '@tanstack/react-query';
import { ExternalLink, Loader2 } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import { FieldError } from '@nesso/ui/primitives/field';
import { Separator } from '@nesso/ui/primitives/separator';

import { createMerchantDashboardLinkOptions } from '@/entities/merchant';
import { useOpenLinkInNewTab } from '@/shared/lib/use-open-link-in-new-tab';
import { SettingsRow } from '@/shared/ui/settings/settings-row';

export function ManageOnlinePaymentsRow() {
    const { mutateAsync, isPending } = useMutation(createMerchantDashboardLinkOptions());
    const { open, hasFailed } = useOpenLinkInNewTab(mutateAsync);

    return (
        <div>
            <Separator className="mb-4" />
            <SettingsRow
                label="Manage your online payments"
                caption="Manage disputes, change your payout schedule, download 1099ks"
                trailing={
                    <div className="flex flex-col items-end gap-2">
                        <Button
                            type="button"
                            size="icon-sm"
                            aria-label="Manage your online payments"
                            disabled={isPending}
                            onClick={open}
                        >
                            {isPending ? <Loader2 className="animate-spin" /> : <ExternalLink />}
                        </Button>
                        {hasFailed && (
                            <FieldError>Couldn't open the dashboard. Try again.</FieldError>
                        )}
                    </div>
                }
            />
        </div>
    );
}
